import "./intro.scss"

function Intro(props) {
    return (
        <div className="intro" id="intro">
            <div className="left">
                <div className="imgContainer">
                    <img src="assets/pic with suit.png" alt="" />
                </div>
            </div>
            <div className="right">
                <div className="wrapper">
                    <h2>Hi, my name is </h2>
                    <h1>Karl Von C. Ta-Octa</h1>
                    <span>I am a graduate of B.S. Computer Science from the University of St. La Salle-Bacolod, Philippines. I have a strong background in IT Hardware/Support, 
                        which includes troubleshooting hardware or software components, assembling PCs, reformatting and troubleshooting Windows Operating Systems, 
                        and creating designs using Photoshop. In addition to that, I have experience and skills in the following areas:</span>
                    <li>
                        •Windows Server 2019 Administration
                    </li>
                    <li>
                        •Utilizing PowerShell for administrative tasks
                    </li>
                    <li>
                        •Managing Active Directory users, computers, groups
                    </li>
                    <li>
                        •Group Policy design
                    </li>
                    <li>
                        •DNS management
                    </li>
                    <li>
                        •Managing virtual machines with Hyper-V
                    </li>
                    <li>
                        •Editing videos using Adobe Premiere Pro
                    </li>
                    <li>
                        •Programming using ReactJS
                    </li>
                    
                    <p>In addition to my education and experience, I have extensive knowledge of Windows Server administration, including deploying Windows Server Desktop Experience and Core, utilizing PowerShell for administrative tasks, managing Active Directory objects, integrating with Azure Active Directory, Group Policy design, DNS management, Windows updates through WSUS, DHCP management, file server administration, and more.</p>
                    <p>I also have hands-on experience in creating and managing virtual machines with Hyper-V, implementing Failover Clustering, ensuring disaster recovery with Windows Backup, enhancing Windows Server security, and monitoring performance. Managing Active Directory users, computers, groups, and more is among my expertise.</p>
                    <p>I believe that my diverse skill set and educational background make me well-equipped for various IT-related roles. Thank you for considering my application.</p>
                    <a href="#portfolio">
                        <img src="assets/down arrow.png" alt="" />
                    </a>
                </div>
            </div>
        </div >
    );
}

export default Intro;